var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "ui-game-info" }, [
    _c("div", { staticClass: "game__info" }, [
      _c("div", { staticClass: "ui-game-fair-game" }, [
        _vm._m(0),
        _c("div", { staticClass: "fair-game__info" }, [
          _c("div", { staticClass: "fair-game__hash" }, [
            _c("div", { staticClass: "fair-game__title" }, [_vm._v("Hash")]),
            _c("div", { staticClass: "fair-game__value" }, [
              _c("input", {
                staticClass: "input",
                attrs: { readonly: "" },
                domProps: { value: _vm.privateSeed },
              }),
            ]),
          ]),
          _c("div", { staticClass: "fair-game__salt" }, [
            _c("div", { staticClass: "fair-game__title" }, [_vm._v("Salt:")]),
            _c("div", { staticClass: "fair-game__value" }, [
              _c("input", {
                staticClass: "input",
                attrs: { readonly: "" },
                domProps: { value: _vm.publicSeed },
              }),
            ]),
          ]),
        ]),
      ]),
      _c("div", { staticClass: "game__stats stats" }, [
        _c(
          "div",
          {
            staticClass: "stats__card common-game-statistic-card",
            attrs: { icon: "users-bold", title: "Players" },
          },
          [
            _c("span", { staticClass: "card__icon icon icon_users-bold" }),
            _c("div", { staticClass: "card__info" }, [
              _c("div", { staticClass: "card__value" }, [
                _c("span", [_vm._v(" " + _vm._s(_vm.playersCount) + " ")]),
                _c("span"),
              ]),
              _c("div", { staticClass: "card__title" }, [_vm._v(" Players ")]),
            ]),
          ]
        ),
        _c(
          "div",
          {
            staticClass: "stats__card common-game-statistic-card",
            attrs: { icon: "money-bold", title: "Bank" },
          },
          [
            _c("span", { staticClass: "card__icon icon icon_money-bold" }),
            _c("div", { staticClass: "card__info" }, [
              _c("div", { staticClass: "card__value" }, [
                _c("span"),
                _c("span", { staticClass: "currency_USD" }, [
                  _vm._v(_vm._s(_vm.playersBetSum)),
                ]),
              ]),
              _c("div", { staticClass: "card__title" }, [_vm._v(" Bank ")]),
            ]),
          ]
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "a",
      {
        staticClass: "btn btn_green",
        attrs: { routerlink: "/provably-fair/realization", href: "" },
      },
      [
        _c("span", { staticClass: "icon icon_shield-bold" }),
        _c("span", { staticClass: "btn__text" }, [_vm._v("Check")]),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }